import { IPartner } from 'clickNgo/entities/partner/models'
import { TPartnerDifference } from 'clickNgo/entities/partner/models'

import { ciEqualsAndHasValue } from '../comparison/ciEqualsAndHasValue'

import { trimIfString } from './trimIfString'

interface ICalculatePartnerDifferenceParams {
  original: IPartner
  compared: IPartner
  fields?: Array<keyof IPartner>
}

export const calculatePartnerDifference = ({
  original,
  compared,
  fields,
}: ICalculatePartnerDifferenceParams): Array<TPartnerDifference> => {
  const mapDifference = (field: keyof IPartner) => {
    const originalValue = trimIfString(original[field])
    const comparedValue = trimIfString(compared[field])
    const isDifferent = !ciEqualsAndHasValue(originalValue, comparedValue)
    const isEmpty = !originalValue && !comparedValue

    return {
      field,
      isDifferent,
      originalValue,
      comparedValue,
      isEmpty,
    }
  }

  if (fields) {
    return fields.map(mapDifference)
  }

  return (Object.keys(original) as Array<keyof IPartner>).map(mapDifference)
}
